export default "__VITE_ASSET__Bd78tuum__"